import React from 'react';
import { DatePicker } from "antd";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;

const DatePickerMenu = ({ onChange, value }) => {

  const [selectedRange, setSelectedRange] = React.useState([]);

  // Usa value do pai (filtro aplicado/localStorage) ou seleção local
  const displayValue = value && (Array.isArray(value) && value.length > 0) ? value : selectedRange;

  const disabledDate = (current) => {
    // Se nada foi selecionado ainda, tudo liberado
    if (!displayValue || displayValue.length === 0) return false;

    const [start] = displayValue;

    if (!start) return false;

    // Limita 1 ano para frente e para trás
    const oneYearAfter = dayjs(start).add(1, "year");
    const oneYearBefore = dayjs(start).subtract(1, "year");

    return current > oneYearAfter || current < oneYearBefore;
  };

  return (
    <RangePicker
      value={displayValue.length > 0 ? displayValue : null}
      onCalendarChange={(dates) => setSelectedRange(dates || [])}
      disabledDate={disabledDate}
      format="DD/MM/YYYY"
      onChange={onChange}
    />
  );
};

export default DatePickerMenu;

